
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {

  ObsBirimAgaci() {
    return $axios.get('FilterUser/ObsBirimAgaci');
  },
  ObsBirimListesi() {
    return $axios.get('FilterUser/ObsBirimListesi');
  },
  PbsBirimListesi() {
    return $axios.get('FilterUser/PbsBirimListesi');
  },
  PbsBirimAgaci(id) {
    return $axios.get('FilterUser/PbsBirimAgaci/' + id);
  },

  OBSPBSOkunabilirAlanlar() {
    return $axios.get('FilterUser/OBSPBSOkunabilirAlanlar');
  },
  PbsPersonels() {
    return $axios.get('FilterUser/PbsPersonels');
  },
  getPersonelByTc(tc) {
    return $axios.get('FilterUser/getPersonelByTc/' + tc);
  },
  listPBSPersonelByParam(param) {

    return $axios.get(`FilterUser/listPBSPersonelByParam/${encodeURIComponent(param)}`);


  },
  listUnvanByTur(tur) {

    return $axios.get(`FilterUser/listUnvanByTur/` + tur);


  },
  listPBSIdariBirimler(){
    return $axios.get('FilterUser/listIdariBirimler');
  
  }

};